import { useEffect, useMemo } from 'react';

import { isEqual } from 'lodash';
import { usePathname, useSearchParams } from 'next/navigation';

const getStorageKey = (prefix: string) => {
  return `${prefix}_QUERY_ENTRIES`;
};

export const useStoreQueryEntries = (prefix: string) => {
  const storageKey = getStorageKey(prefix);
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const url = new URL(location.href);
    const queryEntries = [...url.searchParams];

    const sessionQueryEntries = JSON.parse(
      sessionStorage.getItem(storageKey) || '[]',
    ) as [string, string][];

    if (sessionQueryEntries && !isEqual(queryEntries, sessionQueryEntries)) {
      sessionStorage.setItem(storageKey, JSON.stringify(queryEntries));
    }
  }, [pathname, searchParams, storageKey]);
};

export const useGetQueryEntries = (prefix: string) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const storageKey = getStorageKey(prefix);

  const queryEntries = useMemo(() => {
    if (typeof sessionStorage === 'undefined') {
      return [] as [string, string][];
    }

    return JSON.parse(sessionStorage.getItem(storageKey) || '[]') as [
      string,
      string,
    ][];
  }, [pathname, searchParams, storageKey]);

  return { queryEntries };
};
